import { PosHoldBillHdrContainerModel } from '../../../../../../models/aggregates/erp/pos/pos-hold-bill-hdr-container.model';
import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../../shared/base-api-template-service.model';
import {Core2Config} from '../../shared/core2Config';

@Injectable({
  providedIn: 'root'
})
export class PosHoldBillHdrService extends BaseApiTemplateService<PosHoldBillHdrContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'pos/' + 'hold-bill-hdr';

  constructor(http: HttpClient) {
    super();
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'pos/' + 'hold-bill-hdr';
    this.httpClient = http;
  }
}